import { render, staticRenderFns } from "./HomeBlockChain.vue?vue&type=template&id=73a81176&scoped=true"
import script from "./HomeBlockChain.vue?vue&type=script&lang=js"
export * from "./HomeBlockChain.vue?vue&type=script&lang=js"
import style0 from "./HomeBlockChain.vue?vue&type=style&index=0&id=73a81176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a81176",
  null
  
)

export default component.exports